import EastIcon from "@mui/icons-material/East";
import { Box, keyframes, styled } from "@mui/material";

const wave = keyframes`
  0% { transform: translateX(-100%); opacity: 0; }
  10% { opacity: 0.6; }
  90% { opacity: 0.6; }
  100% { transform: translateX(100%); opacity: 0; }
`;

const EndPointsSeperator = styled(Box)({
  position: "relative",
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const BadgeWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  overflow: "hidden",
  zIndex: 1,
  width: "32px",
  height: "32px",
  borderRadius: "50%",
  backgroundColor: "#ffffff",
  border: "1px solid rgba(0, 0, 0, 0.08)",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    borderRadius: "50%",
    background:
      "linear-gradient(90deg, transparent 0%, rgba(38, 153, 153, 0.25) 40%, rgba(38, 153, 153, 0.25) 60%, transparent 100%)",
    animation: `${wave} 1.8s ease-in-out infinite`,
    pointerEvents: "none",
  },
  "&:hover": {
    transform: "scale(1.25)",
    boxShadow: "0px 6px 15px rgba(38, 153, 153, 0.35)",
    borderColor: theme.palette.primary.main,
  },
}));

function MiddleArrow() {
  return (
    <EndPointsSeperator>
      <BadgeWrapper>
        <EastIcon sx={{ color: "primary.main", fontSize: "1.1rem" }} />
      </BadgeWrapper>
    </EndPointsSeperator>
  );
}

export default MiddleArrow;
